import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormSectionCard } from 'components/_basic/FormSectionCard';

import { concatWithDot } from 'helpers/string';

import { ProfitabilityFormHeader } from './components/ProfitabilityFormHeader';
import { ProfitabilityFormTable } from './components/ProfitabilityFormTable';
import { PROFITABILITY_FORM_NAMES } from './utils/form';
import { FullScreenWrapper } from '../../components/FullScreenWrapper';
import { profitabilityFormPrefix } from '../utils/form';

import styles from './/Profitability.module.scss';

const FormComponent = ({ disabled }: { disabled: boolean }) => {
  return (
    <>
      <ProfitabilityFormHeader disabled={disabled} />
      <ProfitabilityFormTable disabled={disabled} />
    </>
  );
};

export const ProfitabilityForm: React.FC = () => {
  const { t } = useTranslation();

  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.PLANNED_EXPENSES,
  );

  const isDisabled = !canAccess;
  const inputFieldName = concatWithDot(profitabilityFormPrefix, PROFITABILITY_FORM_NAMES.ANTICIPATED_OUTCOME);
  return (
    <>
      <FormSectionCard
        title={t('financialPlan.financialPerformance.profitability.tableDescription')}
        disabled={isDisabled}
      >
        <Box className={styles.content}>
          <FullScreenWrapper title={t('financialPlan.financialPerformance.profitability.tableDescription')}>
            <FormComponent disabled={isDisabled} />
          </FullScreenWrapper>
          <FormSectionCard
            title={t('financialPlan.financialPerformance.profitability.anticipatedOutcome')}
            disabled={isDisabled}
            aiFieldName={inputFieldName}
          >
            <TextInputControl
              multiline
              control={control}
              id={inputFieldName}
              name={inputFieldName}
              minRows={3}
              disabled={isDisabled}
              maxLength={1500}
            />
          </FormSectionCard>
        </Box>
      </FormSectionCard>
    </>
  );
};
